module.exports = __webpack_public_path__ + "static/img/passo3.58829cad.svg";